/**
 * "Bring your own key (BYOK)" — Billing section (ADR-0074).
 * Reconciled from byok.graphql + logic/llm/byok (Anthropic/OpenAI; per
 * tenant+provider+environment; write-only metadata; fail-to-managed default;
 * KMS-encrypted at rest) and the apps/web ByokPage. Billing effect per ADR-0035
 * (Managed +20% vs BYOK no markup).
 */
import type { DocPageContent } from '../types';

export const BILLING_BYOK_PAGE: DocPageContent = {
  slug: 'billing/byok',
  titleKey: 'docs.billing.byok.title',
  descriptionKey: 'docs.billing.byok.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.billing.byok.lead' },

    { kind: 'heading', level: 2, id: 'what', textKey: 'docs.billing.byok.what.heading' },
    { kind: 'paragraph', textKey: 'docs.billing.byok.what.body' },
    {
      kind: 'definitions',
      items: [
        {
          termKey: 'docs.billing.byok.provider.anthropic.term',
          descKey: 'docs.billing.byok.provider.anthropic.desc',
        },
        {
          termKey: 'docs.billing.byok.provider.openai.term',
          descKey: 'docs.billing.byok.provider.openai.desc',
        },
      ],
    },
    {
      kind: 'callout',
      tone: 'tip',
      titleKey: 'docs.billing.byok.markup.title',
      textKey: 'docs.billing.byok.markup.body',
      links: {
        pricing: { target: { path: '/pricing' }, labelKey: 'docs.common.link.pricing' },
      },
    },

    { kind: 'heading', level: 2, id: 'setup', textKey: 'docs.billing.byok.setup.heading' },
    { kind: 'paragraph', textKey: 'docs.billing.byok.setup.body' },
    {
      kind: 'steps',
      steps: [
        {
          titleKey: 'docs.billing.byok.setup.step.open.title',
          textKey: 'docs.billing.byok.setup.step.open.text',
        },
        {
          titleKey: 'docs.billing.byok.setup.step.provider.title',
          textKey: 'docs.billing.byok.setup.step.provider.text',
        },
        {
          titleKey: 'docs.billing.byok.setup.step.paste.title',
          textKey: 'docs.billing.byok.setup.step.paste.text',
        },
      ],
    },
    {
      kind: 'callout',
      tone: 'caution',
      titleKey: 'docs.billing.byok.writeonly.title',
      textKey: 'docs.billing.byok.writeonly.body',
    },

    { kind: 'heading', level: 2, id: 'failover', textKey: 'docs.billing.byok.failover.heading' },
    { kind: 'paragraph', textKey: 'docs.billing.byok.failover.body' },
    {
      kind: 'definitions',
      items: [
        {
          termKey: 'docs.billing.byok.failover.managed.term',
          descKey: 'docs.billing.byok.failover.managed.desc',
        },
        {
          termKey: 'docs.billing.byok.failover.closed.term',
          descKey: 'docs.billing.byok.failover.closed.desc',
        },
      ],
    },

    { kind: 'heading', level: 2, id: 'security', textKey: 'docs.billing.byok.security.heading' },
    {
      kind: 'paragraph',
      textKey: 'docs.billing.byok.security.body',
      links: {
        trust: { target: { path: '/trust' }, labelKey: 'docs.common.link.trust' },
      },
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.billing.byok.next.usage.title',
          textKey: 'docs.billing.byok.next.usage.text',
          to: { docSlug: 'billing/usage' },
        },
        {
          titleKey: 'docs.billing.byok.next.settings.title',
          textKey: 'docs.billing.byok.next.settings.text',
          to: { docSlug: 'dashboard/settings' },
        },
      ],
    },
  ],
};
